/*
 * Module for the the content page, which shows an individual piece of web content
 */

define([
  "jquery",
  "marionette",
  "configuration/properties",
  "messaging/messenger",
  "modules/contentsSplit/content/contentView",
  "modules/contentsSplit/content/contentTitle/contentTitleModule",
  "modules/contentsSplit/content/contentUrls/contentUrlsModule",
  "modules/contentsSplit/content/contentLanguage/contentLanguageModule",
  "modules/contentsSplit/content/contentPreview/contentPreviewModule",
  "modules/contentsSplit/content/contentModel",
  "modules/contentsSplit/content/contentModification/contentModificationModule",
  "modules/shared/sortableList/sortableListModule",
  "./contentTopics/contentTopicsModule",
  "./contentNotes/contentNotesModule",
], function (
  $,
  Marionette,
  Properties,
  Messenger,
  ContentView,
  ContentTitleModule,
  ContentUrlsModule,
  ContentLanguageModule,
  ContentPreviewModule,
  ContentModel,
  ContentModificationModule,
  SortableListModule,
  ContentTopicsModule,
  ContentNotesModule,
) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "content";
      this.region = options.region;
    },
    show: function (content, localeId) {
      content.onSynced(function () {
        if (content.isNew()) {
          document.title = $.t("contents.search.newContent") + " - " + Properties.applicationName;
        } else {
          document.title = content.get("name") + " - " + Properties.applicationName;
        }
      });
      //if the content cannot be loaded, then show an error message and send them to the contents page
      this.listenToOnce(
        content,
        "error",
        function () {
          //if there is an error loading the content, then redirect to the contents page
          Messenger.vent.trigger("show:contents");
          Messenger.okDialog("content.dialog.missing");
        },
        this,
      );
      this.content = content;
      this.layout = new ContentView.contentLayout();
      this.title = this.addSubModule(new ContentTitleModule({ region: this.layout.contentTitle }));
      this.language = this.addSubModule(
        new ContentLanguageModule({
          region: this.layout.contentLanguage,
          selectedSearchLocale: localeId,
        }),
      );
      this.urls = this.addSubModule(
        new ContentUrlsModule({ region: this.layout.contentUrls, selectedSearchLocale: localeId }),
      );
      this.preview = this.addSubModule(
        new ContentPreviewModule({ region: this.layout.contentPreview }),
      );
      // noinspection JSUnusedGlobalSymbols
      this.modification = this.addSubModule(
        new ContentModificationModule({ region: this.layout.contentModification }),
      );
      this.topics = this.addSubModule(
        new ContentTopicsModule({ region: this.layout.contentTopics }),
      );
      this.notes = this.addSubModule(new ContentNotesModule({ region: this.layout.contentNotes }));

      this.content.on(
        "invalid",
        function (_model, error) {
          if ("name" in error) {
            this.title.nameError(error["name"]);
          }
        },
        this,
      );

      //handle deleting content
      this.layout.on(
        "delete:content",
        () => {
          Messenger.yesNoDialog(
            "content.dialog.delete",
            {
              yes: () => {
                Messenger.vent.trigger("track:interaction", {
                  action: "Delete Content",
                  id: this.content.id,
                  idType: "Content",
                  object: "Content",
                });
                Messenger.vent.trigger("cancel:textbox"); //cancel any open textboxes
                this.content.deleteModel();
                //navigate away to the contents page once the content is delete
                Messenger.vent.trigger("show:contents");
              },
            },
            this,
          );
        },
        this,
      );

      //show the content history modal
      this.layout.on(
        "content:history",
        function () {
          const history = this.content.history();
          const headers = Messenger.reqres.request("content:history:headers");

          Messenger.vent.trigger(
            "show:modal",
            SortableListModule,
            {
              headers: headers,
              hideControls: true,
              namespace: "contentHistory",
            },
            history,
            {
              title: "content.history",
              closeButton: true,
              closeOnBackgroundClick: true,
              modalHeight: 600,
              trackInteraction: {
                action: "Content History",
                id: this.content.id,
                idType: "Content",
                object: "Content",
              },
            },
          );
        },
        this,
      );

      this.layout.on(
        "show",
        function () {
          this._showSubViews();
        },
        this,
      );
      const downloadCookie = Messenger.reqres.request("get:download:cookie");
      this.showRegion(this.layout, { loading: true, entity: downloadCookie });
    },
    save: function () {
      console.log("saving content");
      this.content.saveModel();
    },
    _showSubViews: function () {
      this.title.show(this.content);
      this.language.show(this.content);
      this.urls.show(this.content.urls());
      this.preview.show();
      this.topics.show(this.content);
      this.notes.show(this.content);
      //this.modification.show();
    },
  });
});
